// This file is automatically generated. Do not edit it directly.
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

export const isSupabaseConfigured = Boolean(SUPABASE_URL && SUPABASE_PUBLISHABLE_KEY);

function createNoopSupabaseClient(): SupabaseClient<Database> {
  const noopResponse = { data: null, error: new Error('Supabase is not configured') };
  const noopPromise = <T>(value: T) => Promise.resolve(value);

  const noopAuth = {
    signInWithPassword: async () => ({ data: null, error: new Error('Supabase auth not configured') }),
    signUp: async () => ({ data: null, error: new Error('Supabase auth not configured') }),
    signOut: async () => ({ error: new Error('Supabase auth not configured') }),
    getSession: async () => ({ data: { session: null }, error: null }),
    getUser: async () => ({ data: { user: null }, error: null }),
    onAuthStateChange: () => ({ data: null, subscription: { unsubscribe: () => {} } }),
  } as any;

  const noopFrom = () => ({
    select: () => noopPromise(noopResponse),
    insert: () => noopPromise(noopResponse),
    update: () => noopPromise(noopResponse),
    delete: () => noopPromise(noopResponse),
    eq: () => ({ select: () => noopPromise(noopResponse) } as any),
    order: () => ({ select: () => noopPromise(noopResponse) } as any),
    single: () => noopPromise(noopResponse),
  }) as any;

  return {
    auth: noopAuth,
    from: noopFrom,
    rpc: () => noopPromise(noopResponse),
  } as unknown as SupabaseClient<Database>;
}

export const supabase = isSupabaseConfigured
  ? createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
      auth: {
        storage: localStorage,
        persistSession: true,
        autoRefreshToken: true,
      },
    })
  : createNoopSupabaseClient();

if (!isSupabaseConfigured) {
  console.warn(
    'Supabase is not configured. Set VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY in your environment to enable Supabase functionality.'
  );
}
